import { z } from 'zod';
import { uuidV7Schema } from '../uuid.js';
/**
 * Ce que le back-office fournit pour **affecter une demande à une équipe** : l'équipe, et rien
 * d'autre. Le statut qui en découle est dérivé côté serveur (M3, M4) — le laisser au client
 * ferait deux sources pour la même règle du cycle de vie, et la première divergence serait
 * silencieuse.
 *
 * ⚠️ **Pas de date de rendez-vous, et c'est un manque du modèle, pas un choix d'écran.** La table
 * `Appointment` n'existe pas — même absence que les deux onglets sans compteur du tableau
 * (`inquiryListCountsSchema`). Le terrain en pose déjà une dans sa proposition
 * (`inspectionProposalV1Schema.appointment`), donc la forme est connue ; ce qui manque est
 * l'endroit où la ranger. Déclarer le champ ici pour l'ignorer ensuite ferait croire au câblage.
 *
 * `strictObject` : un `status` de trop se rejette au lieu de se retirer en silence — l'appelant
 * croirait avoir imposé la transition.
 */
export const assignInquirySchema = z.strictObject({
    teamId: uuidV7Schema,
});
//# sourceMappingURL=assignment.js.map